/**
 * Détection centralisée des environnements où le ServiceWorker
 * NE DOIT PAS être enregistré (preview Lovable, iframe, dev).
 */
export const isInIframe = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    return true; // Cross-origin → iframe
  }
};

export const isLovablePreviewHost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return (
    h.includes('id-preview--') ||
    h.includes('lovableproject.com') ||
    h.includes('lovable.app')
  );
};

/**
 * Vrai si le SW doit être complètement désactivé dans cet environnement.
 * Couvre : dev local, iframe, et tous les hôtes preview Lovable.
 */
export const shouldDisableServiceWorker = (): boolean => {
  if (typeof window === 'undefined') return true;
  if (import.meta.env.DEV) return true;
  if (isInIframe()) return true;
  if (isLovablePreviewHost()) return true;
  return false;
};
